module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av255-fefd192f21e4e1ec64f44e3eec7a44e3.jpg";